
import React from "react";

interface NotificationIconProps {
    size?: number | string;
    color?: string;
    className?: string;
    onClick?: () => void;
}

const NotificationIcon: React.FC<NotificationIconProps> = ({ size = 20, color = '#1E1E1E' }) => (
    <svg width={size} height={size} viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8 4.29333V6.51334" stroke={color} strokeWidth="1.2" strokeMiterlimit="10" strokeLinecap="round" />
        <path d="M8.01351 1.33337C5.56018 1.33337 3.57351 3.32004 3.57351 5.77337V7.17337C3.57351 7.62671 3.38684 8.30671 3.15351 8.69337L2.30684 10.1067C1.78684 10.98 2.14684 11.9534 3.10684 12.2734C6.29351 13.3334 9.74018 13.3334 12.9268 12.2734C13.8268 11.9734 14.2135 10.92 13.7268 10.1067L12.8802 8.69337C12.6468 8.30671 12.4602 7.62004 12.4602 7.17337V5.77337C12.4535 3.33337 10.4535 1.33337 8.01351 1.33337Z" stroke={color} strokeWidth="1.2" strokeMiterlimit="10" strokeLinecap="round" />
        <path d="M10.22 13.3467C10.22 14.5667 9.22003 15.5667 8.00003 15.5667C7.39336 15.5667 6.83336 15.3133 6.43336 14.9133C6.03336 14.5133 5.78003 13.9533 5.78003 13.3467" stroke={color} strokeWidth="1.2" strokeMiterlimit="10" />
    </svg>


);

export default NotificationIcon;
